const content: { [key: string]: string } = {
  authenticationFailedLinkText: "Click here",
  authenticationFailedText: "Please contact Customer Service",
  authenticationFailedTitle: "Authentication Failed",
  btnBackToAmwayCom: "Back to Amway.com",
  btnBackToHome: "Back to Home",
  cmlLoadFailedText: "Please contact Amway Customer Service",
  cmlLoadFailedTitle: "Something went wrong",
  componentErrorText: "Please try again later",
  componentErrorTitle: "We failed to load this data",
  edLosLoadFailedText: "Please try again later",
  edLosLoadFailedTitle: "We were unable to load the LOS for this ABO",
  genericErrorText: "Please try again later",
  genericErrorTitle: "This application is temporarily unavailable",
  incentiveUnavailableForPeriodText: "Please select another date or return to the dashboard",
  incentiveUnavailableForPeriodTitle:
    "You have selected a date range that has no data or is not currently active in your market",
  incorrectAccountText:
    "Please log into your Business Center using the country-specific credentials for the business you want to view.",
  incorrectAccountTitle: "Logged in With Incorrect Account",
  notAuthorizedText: "You do not have permission to view this page.",
  notAuthorizedTitle: "Not Authorized",
  pageUnavailableText:
    "If you think you have arrived here by mistake, please contact Amway Customer Service Error Code: 404",
  pageUnavailableTitle: "Sorry, we couldn't find this page",
  systemMaintenanceText: "We will be back up and running soon",
  systemMaintenanceTitle: "The site is down for regular maintenance",
  unsupportedBrowserText:
    "CorePlus has been optimized for the following browsers:<br/><strong>Chrome, Safari, Edge, FireFox.</strong><br/></br/>To update your browser, click on one of the icons below.",
  unsupportedBrowserTitle: "We're Sorry, your browser is not supported.",
  userSessionExpiredLinkText: "Click here",
  userSessionExpiredText:
    "Please open your Amway Business Center Site and click on the MyBiz link to get a comprehensive view of your current business status along with detailed information about your Core+ Incentives.",
  userSessionExpiredTitle: "User session expired",
  dashboard: "Dashboard",
  downloadBrowser: "Download {browserName}",
  noDownlines: "You do not have any downlines that meet these criteria.",
};

export default content;
